import { useCallback, useState } from "react";

/**
 * 维护一组 id 的多选状态。
 *
 *   const sel = useSelection();
 *   sel.toggle("c1");       // 选/取消单条
 *   sel.setAll(["c1","c2"]); // 全选当前可见
 *   sel.clear();             // 清空
 *   sel.has("c1");           // 是否选中
 *   sel.ids;                 // string[]
 */
export function useSelection() {
  const [selected, setSelected] = useState<Set<string>>(() => new Set());

  const toggle = useCallback((id: string) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }, []);

  const setAll = useCallback((ids: string[]) => {
    setSelected(new Set(ids));
  }, []);

  const clear = useCallback(() => setSelected(new Set()), []);

  const has = useCallback((id: string) => selected.has(id), [selected]);

  return {
    selected,
    ids: Array.from(selected),
    count: selected.size,
    toggle,
    setAll,
    clear,
    has,
  };
}
